// import { useMemo } from "react";
// import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
// import { useNavigate } from "react-router-dom";
// import { MdEdit, MdDelete, MdMap, MdPublish, MdUnpublished } from "react-icons/md";

// export default function FloorMapTable({ data, loading, onEdit, onDelete, onTogglePublish }) {
//   const navigate = useNavigate();

//   const columns = useMemo(
//     () => [
//       {
//         accessorKey: "map_name",
//         header: "Map Name",
//         size: 200,
//       },
//       {
//         accessorKey: "event_id.event_name",
//         header: "Event",
//         size: 180,
//         Cell: ({ row }) => row.original.event_id?.event_name || "—",
//       },
//       {
//         accessorKey: "floors",
//         header: "Floors",
//         size: 120,
//         Cell: ({ row }) => {
//           const floors = row.original.floors || [];
//           return floors.length > 0
//             ? floors.map((f) => f.floor_label).join(", ")
//             : "—";
//         },
//       },
//       {
//         accessorKey: "status",
//         header: "Status",
//         size: 110,
//         Cell: ({ row }) => (
//           <span
//             className={`rounded-full px-2 py-1 text-xs font-medium ${
//               row.original.status === "published"
//                 ? "bg-green-100 text-green-700"
//                 : "bg-yellow-100 text-yellow-700"
//             }`}
//           >
//             {row.original.status}
//           </span>
//         ),
//       },
//       {
//         id: "actions",
//         header: "Actions",
//         size: 160,
//         Cell: ({ row }) => (
//           <div className="flex items-center gap-2">
//             <button
//               title="Open Builder"
//               className="rounded bg-blue-600 p-1.5 text-white hover:bg-blue-700"
//               onClick={() =>
//                 navigate(`/admin/floor-map/builder/${row.original._id}`)
//               }
//             >
//               <MdMap size={16} />
//             </button>
//             <button
//               title="Edit Details"
//               className="rounded bg-gray-600 p-1.5 text-white hover:bg-gray-700"
//               onClick={() => onEdit(row.original)}
//             >
//               <MdEdit size={16} />
//             </button>
//             <button
//               title={row.original.status === "published" ? "Unpublish" : "Publish"}
//               className={`rounded p-1.5 text-white ${
//                 row.original.status === "published"
//                   ? "bg-yellow-500 hover:bg-yellow-600"
//                   : "bg-green-600 hover:bg-green-700"
//               }`}
//               onClick={() => onTogglePublish(row.original)}
//             >
//               {row.original.status === "published" ? (
//                 <MdUnpublished size={16} />
//               ) : (
//                 <MdPublish size={16} />
//               )}
//             </button>
//             <button
//               title="Delete"
//               className="rounded bg-red-600 p-1.5 text-white hover:bg-red-700"
//               onClick={() => onDelete(row.original)}
//             >
//               <MdDelete size={16} />
//             </button>
//           </div>
//         ),
//       },
//     ],
//     [navigate, onEdit, onDelete, onTogglePublish]
//   );

//   const table = useMaterialReactTable({
//     columns,
//     data: data || [],
//     state: { isLoading: loading },
//     enableColumnFilters: true,
//     enableGlobalFilter: true,
//     enableSorting: true,
//     muiTablePaperProps: { elevation: 0 },
//   });

//   return <MaterialReactTable table={table} />;
// }

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdMoreVert,
  MdEdit,
  MdDelete,
  MdMap,
  MdPublish,
  MdUnpublished,
} from "react-icons/md";

export default function FloorMapTable({
  data,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  onEdit,
  onDelete,
  onTogglePublish,
}) {
  const navigate = useNavigate();
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      setOpenUpward(spaceBelow < 150);
      setOpenDropdownId(rowId);
    }
  };

  return (
    <div className="table-scroll-body">
      <table className="custom-table">
        <thead className="custom-table-header text-gray-800">
          <tr>
            {/* <th className="w-12 text-center">
              <input
                type="checkbox"
                className="table-checkbox"
                onChange={onSelectAll}
                checked={
                  data.length > 0 && selectedRows.length === data.length
                }
              />
            </th> */}
            <th>Map Name</th>
            <th>Event</th>
            <th>Floors</th>
            <th className="text-center">Status</th>
            <th className="w-16 text-center"></th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td
                colSpan="6"
                className="custom-table-cell py-12 text-center text-gray-500"
              >
                No floor maps found
              </td>
            </tr>
          ) : (
            data.map((item, index) => {
              const rowId = item._id || index;
              const isChecked = selectedRows.includes(rowId);
              const isMenuOpen = openDropdownId === rowId;
              const isPublished = item.status === "published";
              const floors = item.floors || [];
              const floorLabels =
                floors.length > 0
                  ? floors.map((f) => f.floor_label).join(", ")
                  : "—";

              return (
                <tr key={rowId} className="custom-table-row">
                  {/* <td className="custom-table-cell text-center">
                    <input
                      type="checkbox"
                      className="table-checkbox"
                      checked={isChecked}
                      onChange={() => onSelectRow(rowId)}
                    />
                  </td> */}

                  <td className="custom-table-cell font-bold text-gray-800">
                    {item.map_name || item.title || item.name || "N/A"}
                  </td>

                  <td className="custom-table-cell ">
                    {item.event_id?.event_name || "—"}
                  </td>

                  <td className="custom-table-cell ">
                    {floorLabels}
                  </td>

                  <td className="custom-table-cell text-center">
                    <span
                      className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
                        isPublished
                          ? "bg-[#dcfce7] text-[#16a34a]"
                          : "bg-[#fef9c3] text-[#ca8a04]"
                      }`}
                    >
                      {item.status || "draft"}
                    </span>
                  </td>

                  {/* Action Dropdown Cell */}
                  <td className="custom-table-cell relative text-center">
                    <button
                      onClick={(e) => handleToggleMenu(e, rowId)}
                      className="action-menu-btn"
                    >
                      <MdMoreVert className="text-lg text-gray-800" />
                    </button>

                    {isMenuOpen && (
                      <div
                        ref={dropdownRef}
                        className={`action-dropdown-menu ${
                          openUpward ? "menu-bottom" : "menu-top"
                        }`}
                      >
                        <button
                          onClick={() => {
                            setOpenDropdownId(null);
                            navigate(`/admin/floor-map/builder/${item._id}`);
                          }}
                          className="action-dropdown-item"
                        >
                          <MdMap className="text-base text-blue-500" />
                          Open Builder
                        </button>

                        <div className="action-dropdown-divider" />

                        <button
                          onClick={() => {
                            setOpenDropdownId(null);
                            onEdit(item);
                          }}
                          className="action-dropdown-item"
                        >
                          <MdEdit className="text-base" />
                          Edit Details
                        </button>

                        <div className="action-dropdown-divider" />

                        <button
                          onClick={() => {
                            setOpenDropdownId(null);
                            onTogglePublish(item);
                          }}
                          className="action-dropdown-item"
                        >
                          {isPublished ? (
                            <>
                              <MdUnpublished className="text-base text-amber-500" />
                              Unpublish
                            </>
                          ) : (
                            <>
                              <MdPublish className="text-base text-green-600" />
                              Publish
                            </>
                          )}
                        </button>

                        <div className="action-dropdown-divider" />

                        <button
                          onClick={() => {
                            setOpenDropdownId(null);
                            onDelete(item);
                          }}
                          className="action-dropdown-item item-danger"
                        >
                          <MdDelete className="text-base" />
                          Delete
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
